const state = {
  items: [],
  keyCounter: 1
}

const actions = {
  addAlert ({ commit }, payload) {
    let obj = {}
    obj.id = state.keyCounter
    obj.type = payload.type
    obj.message = payload.message
    obj.display = true
    obj.limitSecond = payload.limitSecond

    commit('addAlert', obj)

    if (obj.limitSecond > 0) {
      setTimeout(() => {
        commit('hiddenAlert', obj.id)
      }, obj.limitSecond * 1000)
    }
  }
}

const mutations = {
  hiddenAlert (state, id) {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === id) {
        state.items[i].display = false
        return
      }
    }
  },
  addAlert (state, obj) {
    state.items.push(obj)
    state.keyCounter = obj.id + 1
  },
  resetAlert (state) {
    state.items.splice(0, state.items.length)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
